import { render, staticRenderFns } from "./NewEditGestaoDeAulaAEEPage.vue?vue&type=template&id=d0a1ecd8"
import script from "./NewEditGestaoDeAulaAEEPage.vue?vue&type=script&lang=js"
export * from "./NewEditGestaoDeAulaAEEPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports